import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import { useBulkUpdate } from './useBulkUpdate';
import ConceptListSection from './components/ConceptListSection';
import classes from './conceptList.module.scss';

const BulkUpdateModal = () => {
  const {
    ConstrainedForecastViewStore: { isBulkUpdateModalOpen, toggleBulkUpdateModal },
  } = useStore();
  const {
    bulkUpdateDirectTodoNDC,
    bulkUpdateDirectCompletedNDC,
    bulkUpdateIndirectTodoNDC,
    bulkUpdateIndirectCompletedNDC,
  } = useBulkUpdate();

  return (
    <Dialog
      draggable={false}
      resizable={false}
      visible={isBulkUpdateModalOpen}
      onHide={() => {
        if (!isBulkUpdateModalOpen) return;
        toggleBulkUpdateModal();
      }}
      header="Bulk Update Constrained Forecast"
      style={{
        width: '80vw',
      }}
    >
      <div className={classes.conceptListContainer}>
        <ConceptListSection
          heading="To Do"
          directData={bulkUpdateDirectTodoNDC}
          indirectData={bulkUpdateIndirectTodoNDC}
        />
        <ConceptListSection
          heading="Completed"
          directData={bulkUpdateDirectCompletedNDC}
          indirectData={bulkUpdateIndirectCompletedNDC}
        />
      </div>
    </Dialog>
  );
};

export default observer(BulkUpdateModal);
